export default class LoggedInternalLayout {
    balance = null;

    rates = null;
}
